import SDIcon from './SDIcon'

const IconCarbonThumbsUp = (props) => (
  <SDIcon title='ThumbsUp' {...props}>
    <path
    d='M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z'
    transform='translate(0 0)'
    />
  </SDIcon>
)

export default IconCarbonThumbsUp
